import { useState } from "react";
import { useGetCommissionValueMutation } from "../pages/transfer/services/services";
import { enqueueSnackbar } from "notistack";

interface CommissionResult {
    valueFee: number;
    total: number;
}

interface CalculateCommissionParams {
    value: number;
    currencyId: string;
    type: string;
    companyId: number;
    customerId: number;
}

export function useCommission() {
    const [commission, setCommission] = useState<CommissionResult>({ valueFee: 0, total: 0 });
    const [getCommissionValue] = useGetCommissionValueMutation();

    const calculateCommission = async ({ value, currencyId, type, companyId, customerId }: CalculateCommissionParams) => {
        try {
            const payload = {
                value,
                type,
                currencyId,
                companyId: companyId || 0,
                customerId: customerId || 0,
            };
            const response = await getCommissionValue(payload).unwrap();
            const valueFee = response?.data?.valueFee || 0;
            const total = response?.data?.total || 0;
            setCommission({ valueFee, total });
            return { valueFee, total };
        } catch (error) {
            enqueueSnackbar("Komisyon hesaplanırken hata oluştu", { variant: "error" });
            const feeRate = 0.01;
            const valueFee = value * feeRate;
            const total = value + valueFee;
            setCommission({ valueFee, total });
            return { valueFee, total };
        }
    };

    return { commission, calculateCommission };
}
